import $http from '../../../../axios-instance';
import Swal from 'sweetalert2';
import { defaultNfpa } from "./state";

/**
 * Método para obtener las opciones para el control de la sección azul del rombo.
 *
 * @param {*} param0
 */
export async function getOptAzul({commit, state}) {
    await $http.get('controles/5')
        .then((response) => {

            commit('cargarOptAzul', response.data);
        })
        .catch((error) => {

        });
}

/**
 * Método para obtener las opciones para el control de la sección amarilla del rombo.
 *
 * @param {*} param0
 */
export async function getOptAmarillo({commit, state}) {
    await $http.get('controles/5')
        .then((response) => {

            commit('cargarOptAmarillo', response.data);
        })
        .catch((error) => {

        });
}

/**
 * Método para obtener las opciones para el control de la sección blanca del rombo.
 *
 * @param {*} param0
 */
export async function getOptBlanco({commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('controles/13')
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('cargarOptBlanco', response.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Método para guardar la información de NFPA del producto químico.
 *
 * @param {*} param0
 */
export async function guardaNfpa({commit, state, rootState}) {

    let id_producto = rootState.productos.selectedProduct.id;

    if (!id_producto) {
        id_producto = rootState.productos.selectedProduct.Idproducto;
    }
    commit('dashboard/load', true, {root: true});

    await $http.post(`adm_productos/nfpa/crear/${id_producto}`, state.selectedNfpa)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });

            if (rootState.productos.producto_nuevo) {
                commit('sga/setTabActivoSga', 4, {root:true});
            }

        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para obtener la información de NFPA del producto químico.
 *
 * @param {*} param0
 * @param {*} admin contiene la información de nfpa del proceso.
 */
export async function getNfpa({commit, state, rootState}, admin) {

    var producto = rootState.productos.selectedProduct.id;
    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }
    var IdProducto = parseInt(producto);
    var adm;

    if (admin) {
        adm = 1;
    } else {
        adm = 0;
    }
    commit('dashboard/load', true, {root: true});

    await $http.get(`adm_productos/nfpa/ver/${IdProducto}/${adm}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});

            if(Array.isArray(response.data)){
                commit('setNfpa', defaultNfpa());
            }else{
                commit('setNfpa', response.data);
            }
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}
